export default {"src":"/_next/static/media/icon-sanctuary-spiritual-merge.3e30d9ef.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};